<template>
  <div div class="animated fadeIn">
    <b-modal ref="modalCredit" hide-footer title="REEMBOLSO VIAGEM">
     <Forms ref="frmExpense"
      :title="'CADASTRO DE CRÉDITO'"
      :showHelp="false"
      :showClearButton="true"
      :showSaveButton="true"
      v-on:Clear="onClear"
      v-on:Save="onSave">
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label><small class="text-danger">*</small> Crédito:</label>
          <div class="input-group">
            <b-form-select v-model="form.despesaTipoID.value" :options="form.despesaTipoID.options">
              <template slot="first">
                <option :value="null">{{ $lang.Common.PlaceholderSelect }}</option>
              </template>
            </b-form-select>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label for="txtCodePeople"><small v-show="form.dataDespesa.required" class="text-danger">*</small> Data do crédito:</label>
          <div class="input-group">
            <b-form-input type="date"
                          v-model="form.dataDespesa.value"
                          :required="form.dataDespesa.required"
                          :state="form.dataDespesa.state" />
          </div>
        </div>
        <div class="col-md-6">
          <label for="txtGroupsName"><small class="text-danger">*</small> Quantidade:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-calculator"></i></span>
            <money class="form-control form-control-10 text-right"
                          v-bind="integerFormat"
                          placeholder="0"
                          v-model="form.quantidade.value"
                          :size="form.quantidade.maxlength"
                          :state="form.quantidade.state"
                          :required="form.quantidade.required"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Valor:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right"
              v-bind="moneyFormat"
              placeholder="R$ 0,00"
              prefix="R$ "
              v-model="form.valorUnitario.value"
              :size="form.valorUnitario.maxlength"
              :required="form.valorUnitario.required"
              :state="form.valorUnitario.state"/>
          </div>
        </div>
        <div class="col-md-6">
          <label><small class="text-danger">*</small> Total:</label>
          <div class="input-group">
            <span class="input-group-addon"><i class="fas fa-dollar-sign"></i></span>
            <money class="form-control form-control-10 text-right text-bold"
              v-bind="moneyFormat"
              placeholder="R$ 0,00"
              prefix="R$ "
              v-model="Total"
              :size="form.total.maxlength"
              :required="form.total.required"
              :state="form.total.state"
              :disabled="form.total.disabled"/>
          </div>
        </div>
      </div>
      <div class="form-group row pt-2">
        <div class="col-md-12">
          <label for="txtDescription"> Observações:</label>
          <b-form-textarea
            v-model="form.observacao.value"
            :placeholder="''"
            :rows="form.observacao.rows"
            :size="form.observacao.maxlength"
            :noResize="form.observacao.noResize"></b-form-textarea>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12 pt-3">
          <label><small class="text-danger">*</small> Anexar comprovante:</label>
          <div class="input-group" draggable="true" @drop="onUploadDrop" @dragover="onUploadDragover">
            <div class="upload" style="cursor: pointer;" @click="onUploadClick">
              <input
                multiple
                type="file"
                ref="inputFile"
                v-show="false"
                accept="image/*"
                @change="onFileChange"
              />
              <div><i class="fas fa-cloud-upload-alt" style="font-size: 17px"></i></div>
              <span v-if="!attach">Clique aqui para anexar seu comprovante</span>
              <span v-else>
                <span v-for="(upload, index) in attach" :key="index">{{ upload.name }} &nbsp;</span>
              </span>
            </div>
          </div>
        </div>
      </div>
     </Forms>
    </b-modal>
  </div>
</template>
<script>
import { loading } from '@/shared/utils/UIHelper'
import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseItemForm from './modalCredit-form.js'
import ExpenseItemData from '@/shared/models/business/expenseitemmodel.js'
import ExpenseTyeRepository from '@/shared/http/repositories/configuration/expensetype.js'
import ExpenseItemRepository from '@/shared/http/repositories/business/expenseitem.js'
import ExpenseType from '@/shared/utils/expenseType.js'

export default {
  name: 'ExpenseTravelModalCredit',
  mixins: [ ActionsForm ],
  data () {
    return {
      objSelected: null,
      data: ExpenseItemData,
      form: ExpenseItemForm,
      attach: null,
      files: []
    }
  },
  computed: {
    Total: function () {
      return this.form.quantidade.value * this.form.valorUnitario.value
    }
  },
  methods: {
    onLoad () {
      this.onLoadExpenseType()
    },
    showModal (obj) {
      this.objSelected = obj
      this.$refs['modalCredit'].show()
      this.attach = null
      this.files = []
    },
    hideModal () {
      this.$refs['modalCredit'].hide()
    },
    onUploadClick () {
      this.$refs.inputFile.click()
    },
    onUploadDrop (event) {
      console.log('drop', event)
      event.preventDefault()
      let files = event.dataTransfer.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onUploadDragover (event) {
      event.preventDefault()
    },
    onFileChange (event) {
      event.preventDefault()
      let files = event.target.files
      this.attach = files
      if (files && files.length > 0) {
        for (var i in files) {
          if (files[i].size > 0) {
            this.files.push(files[i])
          }
        }
      }
    },
    onCreate () {
      loading.push()
      const formData = new FormData()
      this.data.despesaID = this.objSelected.id
      const json = JSON.stringify(this.data)

      if (this.data.hasOwnProperty('saldo')) {
        delete this.data['saldo']
      }

      // formData.append('file', this.attach)
      formData.append('data', json)
      if (this.files && this.files.length > 0) {
        for (let file of this.files) {
          formData.append('file[]', file)
        }
      } else {
        formData.append('file[]', [])
      }

      ExpenseItemRepository.Create(formData)
        .then((response) => {
          this.hideModal()
          this.onResult(response)
          loading.close()
          this.$emit('Reload')
        })
        .catch(this.onException)
    },
    onUpdate () {
      this.data.status = parseInt(this.data.status)
      if (this.data.hasOwnProperty('saldo')) {
        delete this.data['saldo']
      }
      ExpenseItemRepository.Update(this.data)
        .then(this.onResult)
        .catch(this.onException)
    },
    onLoadExpenseType () {
      ExpenseTyeRepository.GetAllRefund()
        .then((response) => {
          var result = []
          if (response.data.code >= 0) {
            var data = response.data.data
            for (var i in data) {
              if (data[i].status) {
                if (parseInt(data[i].forma) === ExpenseType.CREDIT) {
                  result.push({ 'text': data[i].nome, 'value': data[i].id })
                }
              } else {
                result.push({ 'text': data[i].nome, 'value': data[i].id, disabled: true })
              }
            }
          }
          this.form.despesaTipoID.options = result
        })
        .catch((err) => {
          this.onException(err)
        })
    }
  }
}
</script>
<style scoped>
.upload {
  border: solid 1px #ccc;
  border-radius: 4px;
  background-color: #efefef;
  padding: 5%;
  width: 100%;
  text-align: center;
}
.upload:hover {
  border: solid 1px #008144;
}
.upload:focus {
  border: solid 1px #008144;
}
</style>



// WEBPACK FOOTER //
// src/views/private/finance/expenses/travelrefund/details/components/modal/credit/modalCredit.vue